/** True when the campaign claim deadline has passed. */
export const isCampaignClaimDeadlineExpired = (expiresAt: string | null | undefined): boolean => {
  if (expiresAt == null || expiresAt === '') {
    return false;
  }
  return new Date(expiresAt) <= new Date();
};
